import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog/Dialog';
import AppBar from '@material-ui/core/AppBar/AppBar';
import makeStyles from '@material-ui/styles/makeStyles';
import Toolbar from '@material-ui/core/Toolbar/Toolbar';
import Image from 'next/image';
import { Field, Form } from 'react-final-form';
import { useRouter } from 'next/router';
import { isMobile } from 'react-device-detect';

import {
    BoxCheckDenuncia,
    BoxReportForm,
    CloseFormButton,
    Reportar,
    ReportButton,
    ReportFeedbackContainer,
    ReportFormTitle,
} from './reportarAnuncio-styled';
import Button from '@gjc/classi-react-commons/ClassiButton';
import { InputForm } from '@gjc/classi-react-commons/ClassiInput/input';
import useImoveis from '../../api/imoveis';
import { options } from '../LeadBox/leadBoxCommons';
import { SelectTagForm } from '@gjc/classi-react-commons/ClassiSelect/select';
import { TextAreaForm } from '@gjc/classi-react-commons/ClassiTextArea';
import Loading from '../Loading/Loading';
import { StyledCheckbox } from '@gjc/classi-react-commons/ClassiCheckbox';

import { TextButton } from '../../styles/theme-styled';
import { SetaLeftWhiteSVG } from '../../utils/icons';
import Feedback from '../Feedback';

const required = value => (value ? undefined : 'Obrigatório')

const useStyles = makeStyles({
    paper: {
        backgroundColor: isMobile ? 'none' : 'transparent',
        boxShadow: 'none',
    },
});

const ReportarAnuncio = ({ idAnuncio, listaMotivos }) => {
    const router = useRouter();

    const classes = useStyles();
    const { sendDenuncia } = useImoveis();

    const [isOutroMotivo, setIsOutroMotivo] = useState(false);
    const [placeholder, setPlaceholder] = useState('');
    const [mask, setMask] = useState('');

    const [showReport, setShowReport] = useState(false);

    const [showFeedback, setShowFeedback] = useState(false);
    const [feedbackSuccess, setFeedbackSuccess] = useState(true);

    const objCheckboxDenuncias = listaMotivos.map(function (value) {
        return { descricao: value.descricao, checked: false };
    });

    const [denuncias, setDenuncias] = useState(objCheckboxDenuncias);

    const updateDenunciasObjState = (index) => {
        denuncias[index].checked = denuncias[index].checked !== true;
        setDenuncias([...denuncias]);
    };

    const handleOtherText = (e) => {
        if (e.target.value.length > 0) {
            setIsOutroMotivo(true);
        }
    };

    const hideDialog = () => {
        setShowReport(false);
        setTimeout(() => {
            setShowFeedback(false);
        }, 100);
    };

    const onSubmit = async (mensagem) => {
        if (mensagem.tipoContatoMensagem) {
            mensagem.tipoContatoMensagem = mensagem.tipoContatoMensagem.valor;
        }

        if (mensagem.tipoContatoMensagem === 'EMAIL') {
            mensagem.email = mensagem.contato;
        } else {
            mensagem.telefone = mensagem.contato;
        }

        const checkedDenuncias = denuncias
            .filter((res) => res.checked)
            .map((ele) => ele.descricao);

        const denunciaRequest = {
            idAnuncio: idAnuncio,
            urlAnuncio: process.env.BASE_URL + router.asPath,
            mensagem: mensagem.texto,
            listaMotivo: checkedDenuncias,
        };

        return sendDenuncia(denunciaRequest)
            .then(() => {
                setDenuncias(objCheckboxDenuncias);
                setFeedbackSuccess(true);
                setShowFeedback(true);
            })
            .catch(() => {
                setDenuncias(objCheckboxDenuncias);
                setFeedbackSuccess(false);
                setShowFeedback(true);
            });
    };

    return (
        <>
            <Reportar>
                <ReportButton onClick={() => setShowReport(true)}>
                    <label>Viu algo errado? Reportar anúncio</label>
                </ReportButton>
            </Reportar>

            <Dialog
                open={showReport}
                onClose={() => setShowReport(false)}
                fullScreen={isMobile}
                classes={{ paper: classes.paper }}
            >
                <Form
                    onSubmit={onSubmit}
                    decorators={[]}
                    render={({ handleSubmit, form, submitting, values }) => {
                        const handleContatoChange = (tipoContatoMensagem) => {
                            form.change('contato', null);
                            setMask(tipoContatoMensagem.mask);
                            setPlaceholder(tipoContatoMensagem.placeholder);
                        };

                        return (
                            <>
                                {isMobile ? (
                                    <AppBar
                                        position={'sticky'}
                                        style={{
                                            background: '#30bcd5',
                                        }}
                                    >
                                        <Toolbar>
                                            <TextButton
                                                onClick={() => hideDialog()}
                                            >
                                                <Image
                                                    src={SetaLeftWhiteSVG}
                                                    alt="seta para esquerda"
                                                    width={24}
                                                    height={24}
                                                />
                                            </TextButton>

                                            <h4>Denunciar anúncio</h4>
                                        </Toolbar>
                                    </AppBar>
                                ) : (
                                    <CloseFormButton
                                        onClick={() => setShowReport(false)}
                                    />
                                )}
                                <BoxReportForm isMobile={isMobile}>
                                    {!isMobile && (
                                        <ReportFormTitle>
                                            <span>Denunciar anúncio</span>
                                        </ReportFormTitle>
                                    )}

                                    {!showFeedback && (
                                        <form
                                            style={{ display: "flex", flexDirection: "column" }}
                                            onSubmit={(event) =>
                                                handleSubmit(event)
                                            }
                                        >
                                            {listaMotivos.map((i, index) => {
                                                return (
                                                    <BoxCheckDenuncia
                                                        key={i.id}
                                                    >
                                                        <Field
                                                            name={'denuncia'}
                                                            component={
                                                                StyledCheckbox
                                                            }
                                                            checked={
                                                                denuncias[index]
                                                                    .checked
                                                            }
                                                            onChange={() =>
                                                                updateDenunciasObjState(
                                                                    index
                                                                )
                                                            }
                                                            text={i.descricao}
                                                            color="primary"
                                                        />
                                                    </BoxCheckDenuncia>
                                                );
                                            })}

                                            <BoxCheckDenuncia>
                                                <Field
                                                    name={'denuncia'}
                                                    component={StyledCheckbox}
                                                    onChange={(e) =>
                                                        setIsOutroMotivo(
                                                            e.target.checked
                                                        )
                                                    }
                                                    checked={isOutroMotivo}
                                                    text={'Outros.'}
                                                    color="primary"
                                                />
                                            </BoxCheckDenuncia>
                                            <Field
                                                name="nome"
                                                component={InputForm}
                                                title="Nome"
                                                containerstyle={{
                                                    marginBottom: '20px',
                                                }}
                                                validate={required}
                                            />
                                            <Field
                                                id="tipoContatoMensagem"
                                                name="tipoContatoMensagem"
                                                title="Quero que entre em contato via"
                                                options={options}
                                                component={SelectTagForm}
                                                getOptionValue={(item) =>
                                                    item.valor
                                                }
                                                getOptionLabel={(item) =>
                                                    item.descricao
                                                }
                                                onChange={handleContatoChange}
                                                containerstyle={{
                                                    marginBottom: '20px',
                                                }}
                                                validate={required}
                                            />
                                            <Field
                                                name={'contato'}
                                                title="Contato"
                                                component={InputForm}
                                                mask={mask}
                                                placeholder={placeholder}
                                                disabled={
                                                    !values.tipoContatoMensagem
                                                }
                                                containerstyle={{
                                                    marginBottom: '20px',
                                                }}
                                                validate={required}
                                            />
                                            <Field
                                                name="texto"
                                                component={TextAreaForm}
                                                title="Escreva aqui uma breve descrição da denúncia"
                                                onChange={handleOtherText}
                                                validate={required}
                                            />
                                            <Button
                                                label={'Enviar'}
                                                appearance={'primary'}
                                                style={
                                                    isMobile
                                                        ? {
                                                            backgroundColor:
                                                                '#288394',
                                                            marginLeft: "auto",
                                                            marginRight: "auto",
                                                            marginTop: 15,
                                                            border: 'none',

                                                            width: '100%',
                                                        }
                                                        : {
                                                            backgroundColor:
                                                                '#288394',
                                                            marginTop: 15,
                                                            marginLeft: "auto",
                                                            marginRight: "auto",
                                                            border: 'none',

                                                            width: '50%',
                                                        }
                                                }
                                            />
                                        </form>
                                    )}
                                </BoxReportForm>

                                {submitting && <Loading />}
                            </>
                        );
                    }}
                />

                {showFeedback && (
                    <ReportFeedbackContainer>
                        <Feedback success={feedbackSuccess} />
                        <Button
                            onClick={() => hideDialog()}
                            appearance={'primary'}
                            label={'Voltar'}
                            fontSize={14}
                            height={'30px'}
                            style={{
                                marginLeft: 0,
                                marginRight: 0,
                                backgroundColor: '#288394',
                                border: 'none',
                                width: '100%',
                                alignSelf: 'center',
                            }}
                        />
                    </ReportFeedbackContainer>
                )}
            </Dialog>
        </>
    );
};

export default ReportarAnuncio;
